(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["PCLNAnalytics"] = factory();
	else
		root["PCLNAnalytics"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _environment = __webpack_require__(1);
	
	var _http = __webpack_require__(3);
	
	var _pclnHttpWeb = __webpack_require__(4);
	
	var _pclnAnalytics = __webpack_require__(5);
	
	var _pclnAnalytics2 = _interopRequireDefault(_pclnAnalytics);
	
	var _config = __webpack_require__(22);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEBUG_MODE = (0, _environment.isBrowser)() && !(0, _environment.isProduction)();
	var config = (0, _config2.default)();
	var PCLN_ANALYTICS = new _pclnAnalytics2.default({
	  name: config.NAME,
	  version: config.VERSION,
	  debug: DEBUG_MODE,
	  GAEnabled: (0, _environment.isBrowser)(),
	  batchMeta: function batchMeta() {
	    var appData = (0, _config2.default)();
	
	    return {
	      appName: appData.APP_NAME,
	      appVersion: appData.APP_VERSION,
	      appLocale: appData.APP_LOCALE
	    };
	  }
	});
	
	(0, _http.importHTTP)(_pclnHttpWeb.pclnHTTPWebHandler);
	
	exports.default = PCLN_ANALYTICS;
	
	
	if ((0, _environment.isBrowser)()) {
	  if ((0, _environment.isAngular1)()) {
	    window.angular.module('pcln.analytics', []).factory('PCLNAnalytics', function () {
	      return PCLN_ANALYTICS;
	    });
	  } else {
	    // Cleanup namespace from built umd library
	    window.PCLN = window.PCLN || {};
	    window.PCLN.Analytics = PCLN_ANALYTICS;
	  }
	
	  setTimeout(function () {
	    return delete window.PCLNAnalytics;
	  });
	} else {
	  module.exports = PCLN_ANALYTICS;
	}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isNode = isNode;
	exports.isBrowser = isBrowser;
	exports.isAngular1 = isAngular1;
	exports.isProduction = isProduction;
	exports.isDev = isDev;
	function isNode() {
	  // Close enough
	  return !isBrowser();
	}
	
	function isBrowser() {
	  try {
	    return !!(window && window.document && window.document.createElement);
	  } catch (e) {
	    return false;
	  }
	}
	
	function isAngular1() {
	  return !!(isBrowser() && typeof window.angular !== 'undefined' && window.angular.version.major === 1);
	}
	
	function isProduction() {
	  if (isBrowser()) {
	    return !!(location.protocol.match('http') && !location.host.match(/local|dev|qaa|qab|qac/g));
	  } else {
	    return process.env.NODE_ENV === 'production';
	  }
	}
	
	function isDev() {
	  return !isProduction();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) {
	    return [];
	};
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ERROR_NO_HTTP_HANDLER = undefined;
	exports.importHTTP = importHTTP;
	exports.default = HTTP;
	exports.sendBeacon = sendBeacon;
	
	var _environment = __webpack_require__(1);
	
	var http = null;
	
	var ERROR_NO_HTTP_HANDLER = exports.ERROR_NO_HTTP_HANDLER = "NO HTTP handler found";
	
	function importHTTP(handler) {
	  http = handler;
	}
	
	function HTTP() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return new Promise(function (resolve, reject) {
	    if (typeof http === 'function') {
	      http.apply(undefined, args).then(resolve).catch(reject);
	    } else {
	      reject(ERROR_NO_HTTP_HANDLER);
	    }
	  });
	}
	
	function sendBeacon(url, data) {
	  if ((0, _environment.isBrowser)() && navigator.sendBeacon) {
	    navigator.sendBeacon(url, data);
	  } else {
	    HTTP({ url: url, data: data }, false);
	  }
	}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pclnHTTPWebHandler = pclnHTTPWebHandler;
	
	var _http = __webpack_require__(3);
	
	function pclnHTTPWebHandler() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  return new Promise(function (resolve, reject) {
	    var type = options.type || options.data ? 'POST' : 'GET';
	    var data = options.data && type === 'POST' ? JSON.stringify(options.data) : undefined;
	    var dataType = options.dataType ? options.dataType : type === 'POST' ? 'json' : '';
	
	    if (options.beacon) {
	      (0, _http.sendBeacon)(options.url, data);
	    } else {
	      var xhr = new XMLHttpRequest();
	
	      xhr.addEventListener('load', function (response) {
	        resolve(response);
	      });
	      xhr.addEventListener('error', function (error) {
	        return reject(error);
	      });
	      xhr.open(type, options.url, async);
	
	      if (type === 'POST') {
	        xhr.setRequestHeader('Content-Type', 'application/json');
	      }
	
	      xhr.send(data);
	    }
	  });
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _logManager = __webpack_require__(6);
	
	var _logManager2 = _interopRequireDefault(_logManager);
	
	var _logs = __webpack_require__(11);
	
	var _elasticSearchProvider2 = __webpack_require__(12);
	
	var _elasticSearchProvider3 = _interopRequireDefault(_elasticSearchProvider2);
	
	var _splunkProvider2 = __webpack_require__(14);
	
	var _splunkProvider3 = _interopRequireDefault(_splunkProvider2);
	
	var _gtmProvider2 = __webpack_require__(15);
	
	var _gtmProvider3 = _interopRequireDefault(_gtmProvider2);
	
	var _browserErrorBehavior2 = __webpack_require__(16);
	
	var _browserErrorBehavior3 = _interopRequireDefault(_browserErrorBehavior2);
	
	var _pageVisibilityBehavior2 = __webpack_require__(17);
	
	var _pageVisibilityBehavior3 = _interopRequireDefault(_pageVisibilityBehavior2);
	
	var _pclnData = __webpack_require__(18);
	
	var _storage = __webpack_require__(19);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _string = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _browserErrorBehavior = (0, _string.uniqueString)('PCLNAnalytics_browserErrorBehavior');
	var _showDebugs = (0, _string.uniqueString)('PCLNAnalytics_showDebugs');
	var _loggedKeys = (0, _string.uniqueString)('PCLNAnalytics_loggedKeys');
	var _pageVisibilityBehavior = (0, _string.uniqueString)('PCLNAnalytics_ pageVisibilityBehavior');
	var _elasticSearchProvider = (0, _string.uniqueString)('PCLNAnalytics_elasticSearchProvider');
	var _gtmProvider = (0, _string.uniqueString)('PCLNAnalytics_gtmProvider');
	var _splunkProvider = (0, _string.uniqueString)('PCLNAnalytics_splunkProvider');
	
	var PCLNAnalytics = function () {
	  function PCLNAnalytics(config) {
	    var _this = this;
	
	    _classCallCheck(this, PCLNAnalytics);
	
	    config = _extends({}, config, _storage2.default.state);
	
	    this[_showDebugs] = false;
	    this[_loggedKeys] = {};
	    this[_elasticSearchProvider] = new _elasticSearchProvider3.default(config);
	    this[_splunkProvider] = new _splunkProvider3.default(config);
	    this[_gtmProvider] = new _gtmProvider3.default({ debug: config.debug, max: config.maxLogs });
	
	    this[_browserErrorBehavior] = new _browserErrorBehavior3.default(function (error) {
	      return _this.logError(error);
	    });
	    this[_pageVisibilityBehavior] = new _pageVisibilityBehavior3.default(function (hidden) {
	      if (hidden) _logManager2.default.instance.release({ manual: true });
	    });
	
	    this.name = config.name;
	    this.version = config.version;
	    this.debugMode = config.debug || false;
	    this.GAEnabled = typeof config.GAEnabled == "boolean" ? config.GAEnabled : true;
	  }
	
	  _createClass(PCLNAnalytics, [{
	    key: 'log',
	    value: function log(data, priority) {
	      var valid = this.validateLog(data, _logs.LOG_TYPES.DEFAULT);
	
	      if (valid) this[_elasticSearchProvider].log(data, priority);
	    }
	  }, {
	    key: 'logError',
	    value: function logError() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var priority = arguments[1];
	
	      var valid = this.validateLog(data, _logs.LOG_TYPES.ERROR);
	
	      if (valid) this[_elasticSearchProvider].log(new _logs.ErrorLog(data, this[_showDebugs]), priority);
	    }
	  }, {
	    key: 'logEvent',
	    value: function logEvent() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var priority = arguments[1];
	
	      if (data.event == "seti") {
	        this.logSeti(data, priority);
	
	        return;
	      }
	
	      var valid = this.validateLog(data, _logs.LOG_TYPES.EVENT);
	      var event = data instanceof _logs.Log ? data : new _logs.EventLog(data);
	
	      if (valid) {
	        if (this.GAEnabled) this[_gtmProvider].log(event);
	
	        this[_elasticSearchProvider].log(event, priority);
	      }
	    }
	  }, {
	    key: 'logSeti',
	    value: function logSeti() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var priority = arguments[1];
	
	      this.logEvent(new _logs.SetiLog(data));
	    }
	
	    //often only want to log a SETI dimension once per app instance
	
	  }, {
	    key: 'logSetiOnce',
	    value: function logSetiOnce() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var logKey = arguments[1];
	      var priority = arguments[2];
	
	      if (logKey && this[_loggedKeys][logKey]) {
	        return;
	      }
	
	      this[_loggedKeys][logKey] = true;
	      this.logEvent(new _logs.SetiLog(data));
	    }
	  }, {
	    key: 'logWarning',
	    value: function logWarning() {
	      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var priority = arguments[1];
	
	      var valid = this.validateLog(data, _logs.LOG_TYPES.WARNING);
	
	      if (valid) this[_elasticSearchProvider].log(new _logs.WarningLog(data, this[_showDebugs]), priority);
	    }
	  }, {
	    key: 'validateLog',
	    value: function validateLog(log) {
	      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _logs.LOG_TYPES.DEFAULT;
	
	      var valid = _logs.Log.isLog(log);
	
	      if (valid) {
	        if (!(log instanceof _logs.Log) && log.type) {
	          var message = 'PCLNAnalytics.validateLog -> log.type should not be specified -> Overriding ' + log.type + ' with ' + type + '.';
	
	          this.logWarning({ message: message });
	        }
	      } else {
	        var severity = 9;
	        var _message = 'PCLNAnalytics.validateLog -> Invalid Log -> type: ' + (typeof log === 'undefined' ? 'undefined' : _typeof(log)) + ', value: ' + log;
	
	        this.logError({ severity: severity, message: _message });
	      }
	
	      return valid;
	    }
	  }, {
	    key: 'appName',
	    set: function set(appName) {
	      (0, _pclnData.updatePCLNData)({ appName: appName });
	    }
	  }, {
	    key: 'appVersion',
	    set: function set(appVersion) {
	      (0, _pclnData.updatePCLNData)({ appVersion: appVersion });
	    }
	  }, {
	    key: 'debugMode',
	    set: function set() {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      this[_showDebugs] = state;
	
	      _storage2.default.save('debug', state);
	    }
	  }]);
	
	  return PCLNAnalytics;
	}();
	
	exports.default = PCLNAnalytics;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _priorityQueue = __webpack_require__(7);
	
	var _priorityQueue2 = _interopRequireDefault(_priorityQueue);
	
	var _taskPool2 = __webpack_require__(9);
	
	var _taskPool3 = _interopRequireDefault(_taskPool2);
	
	var _logs = __webpack_require__(11);
	
	var _string = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _batchSize = (0, _string.uniqueString)('LogManager_batchSize');
	var _batchDelay = (0, _string.uniqueString)('LogManager_batchDelay');
	var _batchMeta = (0, _string.uniqueString)('LogManager_batchMeta');
	var _instance = (0, _string.uniqueString)('LogManager_instance');
	var _taskPool = (0, _string.uniqueString)('LogManager_taskPool');
	var _providers = (0, _string.uniqueString)('LogManager_providers');
	var _queue = (0, _string.uniqueString)('LogManager_queue');
	var _manualReleaseTimeout = (0, _string.uniqueString)('LogManager_manualReleaseTimeout');
	var _maxLogs = (0, _string.uniqueString)('LogManager_maxLogs');
	var _resolveDelay = (0, _string.uniqueString)('LogManager_resolveDelay');
	var _running = (0, _string.uniqueString)('LogManager_running');
	
	var LogManager = function () {
	  function LogManager() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, LogManager);
	
	    this[_taskPool] = new _taskPool3.default({
	      poolSize: 5
	    });
	
	    this[_batchSize] = config.batchSize || 30;
	    this[_batchDelay] = config.batchDelay || 5000;
	    this[_batchMeta] = config.batchMeta;
	    this[_providers] = {};
	    this[_queue] = new _priorityQueue2.default();
	    this[_manualReleaseTimeout] = null;
	    this[_maxLogs] = config.maxLogs || 1000;
	    this[_resolveDelay] = config.resolveDelay || 500;
	    this[_running] = false;
	  }
	
	  _createClass(LogManager, [{
	    key: 'log',
	    value: function log(data, priority, provider) {
	      if (this[_queue].size >= this[_maxLogs]) return;
	
	      var log = data instanceof _logs.Log ? data : new _logs.Log(data);
	
	      if (provider) log.provider = provider;
	
	      this[_queue].enqueue(log, priority);
	      this._start();
	    }
	  }, {
	    key: 'release',
	    value: function release(meta) {
	      var _this = this;
	
	      if (this[_manualReleaseTimeout]) return;
	
	      this[_manualReleaseTimeout] = setTimeout(function () {
	        _this[_manualReleaseTimeout] = clearTimeout(_this[_manualReleaseTimeout]);
	      }, this[_batchDelay]);
	
	      this._send(meta);
	    }
	  }, {
	    key: '_start',
	    value: function _start() {
	      this[_running] = true;
	
	      setTimeout(this._send.bind(this), this[_batchDelay]);
	    }
	  }, {
	    key: '_send',
	    value: function _send() {
	      var _this2 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      if (!this[_running] || this[_taskPool].full) return;
	
	      var batchSize = this[_batchSize];
	      var totalProviders = this[_taskPool].max - this[_taskPool].size;
	      var providers = LogManager.parseProviders(this[_queue], batchSize, totalProviders);
	      var manual = !!options.manual;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var _step$value = _slicedToArray(_step.value, 2),
	              provider = _step$value[0],
	              state = _step$value[1];
	
	          var batchCount = Math.ceil(state.data.length / batchSize);
	
	          var _loop2 = function _loop2(i) {
	            var index = i * batchSize;
	            var lastIndex = index + batchSize;
	            var logs = state.data.slice(index, lastIndex);
	
	            _this2[_taskPool].add(function () {
	              return provider.onBatch(logs, { manual: manual }).then(function () {
	                if (_this2[_queue].size && !manual) {
	                  setTimeout(_this2._send.bind(_this2), 1000);
	                } else {
	                  _this2[_running] = false;
	                }
	              });
	            });
	          };
	
	          for (var i = 0; i < batchCount; ++i) {
	            _loop2(i);
	          }
	        };
	
	        for (var _iterator = providers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: '_stop',
	    value: function _stop() {
	      if (!this[_running]) return;
	
	      this[_running] = false;
	    }
	  }, {
	    key: 'running',
	    get: function get() {
	      return this[_running];
	    }
	  }], [{
	    key: 'parseProviders',
	    value: function parseProviders(queue, count, max) {
	      var p = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Map();
	
	      var diff = count > queue.size ? count - queue.size : count;
	
	      for (var i = 0; i < diff; ++i) {
	        var next = queue.front;
	
	        if (!next) break;
	        if (!p.has(next.provider) && p.size <= max) {
	          p.set(next.provider, { data: [] });
	        }
	
	        p.get(next.provider).data.push(queue.dequeue());
	      }
	
	      if (!queue.empty && p.size < max) {
	        this.parseProviders(queue, count, --max, p);
	      }
	
	      return p;
	    }
	  }, {
	    key: 'instance',
	    get: function get() {
	      if (!this[_instance]) this[_instance] = new LogManager();
	
	      return this[_instance];
	    }
	  }]);
	
	  return LogManager;
	}();
	
	exports.default = LogManager;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PriorityQueueItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _string = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _data = (0, _string.uniqueString)('PriorityQueue_data');
	var _priority = (0, _string.uniqueString)('PriorityQueue_priority');
	var _queue = (0, _string.uniqueString)('PriorityQueue_queue');
	
	var PriorityQueueItem = exports.PriorityQueueItem = function () {
	  function PriorityQueueItem() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var priority = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
	
	    _classCallCheck(this, PriorityQueueItem);
	
	    this[_data] = data;
	    this[_priority] = priority;
	  }
	
	  _createClass(PriorityQueueItem, [{
	    key: 'data',
	    get: function get() {
	      return this[_data];
	    }
	  }, {
	    key: 'priority',
	    get: function get() {
	      return this[_priority];
	    }
	  }]);
	
	  return PriorityQueueItem;
	}();
	
	var PriorityQueue = function () {
	  function PriorityQueue() {
	    _classCallCheck(this, PriorityQueue);
	
	    this[_queue] = [];
	  }
	
	  _createClass(PriorityQueue, [{
	    key: 'enqueue',
	    value: function enqueue(element) {
	      var priority = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
	
	      if (priority < 1) priority = 1;else if (priority > 9) priority = 9;
	
	      var queueItem = new PriorityQueueItem(element, priority);
	      var queue = this[_queue];
	
	      if (this.empty) {
	        this[_queue].push(queueItem);
	      } else {
	        var added = false;
	
	        for (var i = 0; i < queue.length; ++i) {
	          if (priority < queue[i].priority) {
	            queue.splice(i, 0, queueItem);
	
	            added = true;
	
	            break;
	          }
	        }
	
	        if (!added) this[_queue].push(queueItem);
	      }
	    }
	  }, {
	    key: 'dequeue',
	    value: function dequeue() {
	      if (this.empty) return;
	
	      return this[_queue].shift().data;
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this[_queue] = [];
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      return this[_queue].length;
	    }
	  }, {
	    key: 'empty',
	    get: function get() {
	      return this[_queue].length === 0;
	    }
	  }, {
	    key: 'front',
	    get: function get() {
	      return this[_queue][0] ? this[_queue][0].data : null;
	    }
	  }]);
	
	  return PriorityQueue;
	}();
	
	exports.default = PriorityQueue;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.version = version;
	function version() {
	  var full = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0.0.0';
	  var codeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  if (typeof full !== "string") full = "0.0.0";
	
	  var _full$split = full.split(/\./g),
	      _full$split2 = _slicedToArray(_full$split, 3),
	      major = _full$split2[0],
	      minor = _full$split2[1],
	      dot = _full$split2[2];
	
	  major = Number(major) || 0;
	  minor = Number(minor) || 0;
	  dot = Number(dot) || 0;
	
	  var v = {
	    full: full,
	    major: major,
	    minor: minor,
	    dot: dot
	  };
	
	  if (codeName) v.codeName = codeName;
	
	  return v;
	}
	
	//Given an input return a unique string based on a timestamp
	var uniqueString = exports.uniqueString = function uniqueString(strName) {
	  var ts = Date.now();
	  return strName + ' ' + ts;
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _string = __webpack_require__(8);
	
	var _queue2 = __webpack_require__(10);
	
	var _queue3 = _interopRequireDefault(_queue2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _pool = (0, _string.uniqueString)('TaskPool_pool');
	var _queue = (0, _string.uniqueString)('TaskPool_queue');
	var _maxPoolSize = (0, _string.uniqueString)('TaskPool_maxPoolSize');
	var _maxQueueSize = (0, _string.uniqueString)('TaskPool_maxQueueSize');
	
	var TaskPool = function () {
	  function TaskPool() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, TaskPool);
	
	    this[_maxPoolSize] = config.poolSize || 10;
	    this[_maxQueueSize] = config.queueSize || 1000;
	    this[_pool] = [];
	    this[_queue] = new _queue3.default();
	  }
	
	  _createClass(TaskPool, [{
	    key: 'add',
	    value: function add() {
	      for (var _len = arguments.length, tasks = Array(_len), _key = 0; _key < _len; _key++) {
	        tasks[_key] = arguments[_key];
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = tasks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var task = _step.value;
	
	          if (this[_pool].length < this[_maxPoolSize]) {
	            this._run(task);
	          } else if (this[_queue].size < this[_maxQueueSize]) {
	            this[_queue].enqueue(task);
	          } else {
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: '_run',
	    value: function _run(task) {
	      var _this = this;
	
	      var promise = task() || Promise.resolve();
	      var done = function done(_) {
	        return _this._complete(promise);
	      };
	
	      promise.then(done).catch(done);
	      this[_pool].push(promise);
	    }
	  }, {
	    key: '_complete',
	    value: function _complete(promise) {
	      var index = this[_pool].indexOf(promise);
	
	      if (index < 0) return;
	
	      this[_pool].splice(index, 1);
	
	      if (!this.full && this[_queue.size]) {
	        var sizeDiff = this[_maxPoolSize] - this[_queue].size;
	
	        for (var i = 0; i < sizeDiff; ++i) {
	          this._run(this[_queue].dequeue());
	        }
	      }
	    }
	  }, {
	    key: 'max',
	    get: function get() {
	      return this[_maxPoolSize];
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      return this[_pool].length;
	    }
	  }, {
	    key: 'queueSize',
	    get: function get() {
	      return this[_queue].size;
	    }
	  }, {
	    key: 'empty',
	    get: function get() {
	      return !this.size;
	    }
	  }, {
	    key: 'full',
	    get: function get() {
	      return this.size === this[_maxPoolSize];
	    }
	  }]);
	
	  return TaskPool;
	}();
	
	exports.default = TaskPool;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _string = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _maxSize = (0, _string.uniqueString)('Queue_maxSize');
	var _queue = (0, _string.uniqueString)('Queue_queue');
	
	var Queue = function () {
	  function Queue() {
	    var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
	
	    _classCallCheck(this, Queue);
	
	    this[_queue] = [];
	    this[_maxSize] = Number(maxSize);
	  }
	
	  _createClass(Queue, [{
	    key: 'enqueue',
	    value: function enqueue(element) {
	      if (this.size >= this[_maxSize]) return;
	
	      this[_queue].push(element);
	    }
	  }, {
	    key: 'dequeue',
	    value: function dequeue(element) {
	      return this[_queue].shift();
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this[_queue] = [];
	    }
	  }, {
	    key: 'size',
	    get: function get() {
	      return this[_queue].length;
	    }
	  }, {
	    key: 'empty',
	    get: function get() {
	      return this[_queue].length === 0;
	    }
	  }, {
	    key: 'front',
	    get: function get() {
	      return this[_queue][0];
	    }
	  }]);
	
	  return Queue;
	}();
	
	exports.default = Queue;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WarningLog = exports.SetiLog = exports.EventLog = exports.ErrorLog = exports.Log = exports.LOG_TYPES = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _environment = __webpack_require__(1);
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LOG_TYPES = exports.LOG_TYPES = {
	  DEFAULT: 'Log',
	  ERROR: 'Error',
	  EVENT: 'Event',
	  SETI: 'Seti',
	  WARNING: 'Warning'
	};
	var MAX_LOG_KEYS = 50;
	var MAX_LOG_STRING_LENGTH = 1000;
	
	var Log = exports.Log = function () {
	  function Log(data, provider) {
	    _classCallCheck(this, Log);
	
	    this.type = LOG_TYPES.DEFAULT;
	    this.data = data;
	    this.timestamp = new Date();
	    this.provider = provider;
	
	    if ((0, _environment.isBrowser)()) this.url = window.location.href;
	  }
	
	  _createClass(Log, [{
	    key: 'serialize',
	    value: function serialize() {
	      var data = {};
	      var keySize = 0;
	
	      for (var prop in this.data) {
	        if (keySize > MAX_LOG_KEYS) break;
	
	        var value = this.data[prop];
	
	        // Ignore null/undefined values 
	        if (!value) continue;
	        // Ignore Objects && Arrays
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value instanceof Date === false) continue;
	        // Trim strings if necessary
	        if (typeof value === 'string' && value.length > MAX_LOG_STRING_LENGTH) {
	          value = '[TRUNC] ' + value.substring(0, MAX_LOG_STRING_LENGTH);
	        }
	
	        data[prop] = value;
	        keySize++;
	      }
	
	      // Gonzo 7/24/2017 - The line below breaks GA by overwriting the "action" property.
	      //   However, it looks like other logging, such as Elasticsearch, depends on that "action" value being present.
	      //   So for now we only override it when there is no action already present.
	      if (data.action === null || data.action === undefined) {
	        data.action = this.type;
	      }
	
	      data.timestamp = this.timestamp;
	
	      if (this.url) data.url = this.url;
	
	      return data;
	    }
	  }], [{
	    key: 'isLog',
	    value: function isLog(data) {
	      return (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && !Array.isArray(data) && data instanceof Date === false;
	    }
	  }]);
	
	  return Log;
	}();
	
	var ErrorLog = exports.ErrorLog = function (_Log) {
	  _inherits(ErrorLog, _Log);
	
	  function ErrorLog(data, logToConsole) {
	    _classCallCheck(this, ErrorLog);
	
	    var _this = _possibleConstructorReturn(this, (ErrorLog.__proto__ || Object.getPrototypeOf(ErrorLog)).call(this, data));
	
	    _this.type = LOG_TYPES.ERROR;
	    var defaultSeverityLevel = 9;
	    _this.data = _extends({}, data, { severity: data.severity || defaultSeverityLevel
	    });
	
	    if (logToConsole) console.error('PCLNAnalytics ErrorLog : ' + data.message);
	    return _this;
	  }
	
	  return ErrorLog;
	}(Log);
	
	var EventLog = exports.EventLog = function (_Log2) {
	  _inherits(EventLog, _Log2);
	
	  function EventLog(data) {
	    _classCallCheck(this, EventLog);
	
	    var _this2 = _possibleConstructorReturn(this, (EventLog.__proto__ || Object.getPrototypeOf(EventLog)).call(this, data));
	
	    _this2.type = LOG_TYPES.EVENT;
	    return _this2;
	  }
	
	  return EventLog;
	}(Log);
	
	var SetiLog = exports.SetiLog = function (_Log3) {
	  _inherits(SetiLog, _Log3);
	
	  function SetiLog(data) {
	    _classCallCheck(this, SetiLog);
	
	    var _this3 = _possibleConstructorReturn(this, (SetiLog.__proto__ || Object.getPrototypeOf(SetiLog)).call(this, data));
	
	    _this3.type = LOG_TYPES.SETI;
	
	    _this3.data = _extends({}, data, {
	      event: 'seti'
	    });
	    return _this3;
	  }
	
	  return SetiLog;
	}(Log);
	
	var WarningLog = exports.WarningLog = function (_Log4) {
	  _inherits(WarningLog, _Log4);
	
	  function WarningLog(data, logToConsole) {
	    _classCallCheck(this, WarningLog);
	
	    var _this4 = _possibleConstructorReturn(this, (WarningLog.__proto__ || Object.getPrototypeOf(WarningLog)).call(this, data));
	
	    _this4.type = LOG_TYPES.WARNING;
	
	    if (logToConsole) console.warn('PCLNAnalytics WarningLog : ' + data.message);
	    return _this4;
	  }
	
	  return WarningLog;
	}(Log);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _http = __webpack_require__(3);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _logProvider = __webpack_require__(13);
	
	var _logProvider2 = _interopRequireDefault(_logProvider);
	
	var _taskPool = __webpack_require__(9);
	
	var _taskPool2 = _interopRequireDefault(_taskPool);
	
	var _string = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _httpPool = (0, _string.uniqueString)('ElasticSearchProvider_httpPool');
	var _meta = (0, _string.uniqueString)('ElasticSearchProvider_meta');
	
	var ES_ENDPOINT = '/pws/v0/fly/tag/batch';
	
	var ElasticSearchProvider = function (_LogProvider) {
	  _inherits(ElasticSearchProvider, _LogProvider);
	
	  _createClass(ElasticSearchProvider, null, [{
	    key: 'is',
	    get: function get() {
	      return 'ElasticSearchProvider';
	    }
	  }]);
	
	  function ElasticSearchProvider(config) {
	    _classCallCheck(this, ElasticSearchProvider);
	
	    var _this = _possibleConstructorReturn(this, (ElasticSearchProvider.__proto__ || Object.getPrototypeOf(ElasticSearchProvider)).call(this, config));
	
	    _this[_httpPool] = new _taskPool2.default();
	    _this[_meta] = config.batchMeta;
	    return _this;
	  }
	
	  _createClass(ElasticSearchProvider, [{
	    key: 'onBatch',
	    value: function onBatch(batch, meta) {
	      return (0, _http2.default)({
	        url: ES_ENDPOINT,
	        data: this._createRequest(batch),
	        beacon: meta.manual
	      });
	    }
	  }, {
	    key: '_createRequest',
	    value: function _createRequest(logs) {
	      var request = {
	        tags: logs.map(function (log) {
	          return {
	            data: log.serialize()
	          };
	        }),
	        timestamp: new Date()
	      };
	      var meta = this[_meta];
	
	      meta = typeof meta === 'function' ? meta() : meta;
	
	      if (meta) {
	        return _extends({}, request, meta);
	      }
	      return request;
	    }
	  }]);
	
	  return ElasticSearchProvider;
	}(_logProvider2.default);
	
	exports.default = ElasticSearchProvider;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _logManager = __webpack_require__(6);
	
	var _logManager2 = _interopRequireDefault(_logManager);
	
	var _string = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _batchListener = (0, _string.uniqueString)('LogProvider_batchListener');
	
	var LogProvider = function () {
	  function LogProvider() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, LogProvider);
	
	    if (typeof this.constructor.is !== 'string') {
	      throw new Error('LogProvider -> static property `is` required');
	    }
	
	    this.debugMode = config.debug || false;
	
	    this[_batchListener] = null;
	  }
	
	  _createClass(LogProvider, [{
	    key: 'log',
	    value: function log(data, priority) {
	      _logManager2.default.instance.log(data, priority, this);
	    }
	  }, {
	    key: 'onBatch',
	    value: function onBatch() {/* override */}
	  }, {
	    key: 'addBatchListener',
	    value: function addBatchListener() {
	      var _this = this;
	
	      if (this[_batchListener]) return;
	
	      this[_batchListener] = function (batch) {
	        var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (batch.contains(_this)) {
	          var logs = batch.get(_this);
	
	          _this.printBatch(logs);
	          _this.onBatch(logs, meta);
	        }
	      };
	
	      _logManager2.default.instance.on('batch', this[_batchListener]);
	    }
	  }, {
	    key: 'removeBatchListener',
	    value: function removeBatchListener() {
	      if (!this[_batchListener]) return;
	
	      _logManager2.default.instance.off('batch', this[_batchListener]);
	    }
	  }, {
	    key: 'printBatch',
	    value: function printBatch(batch) {
	      if (this.debugMode) {
	        console.log('BATCH : ' + this.constructor.is + ' -> ' + batch.length + ' logs', batch);
	      }
	    }
	  }]);
	
	  return LogProvider;
	}();
	
	exports.default = LogProvider;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _http = __webpack_require__(3);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _logProvider = __webpack_require__(13);
	
	var _logProvider2 = _interopRequireDefault(_logProvider);
	
	var _taskPool = __webpack_require__(9);
	
	var _taskPool2 = _interopRequireDefault(_taskPool);
	
	var _string = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SPLUNK_ENDPOINT = '/splunk';
	
	var _httpPool = (0, _string.uniqueString)('SplunkProvider_httpPool');
	var _meta = (0, _string.uniqueString)('SplunkProvider_meta');
	
	var SplunkProvider = function (_LogProvider) {
	  _inherits(SplunkProvider, _LogProvider);
	
	  _createClass(SplunkProvider, null, [{
	    key: 'is',
	    get: function get() {
	      return 'SplunkProvider';
	    }
	  }]);
	
	  function SplunkProvider(config) {
	    _classCallCheck(this, SplunkProvider);
	
	    var _this = _possibleConstructorReturn(this, (SplunkProvider.__proto__ || Object.getPrototypeOf(SplunkProvider)).call(this, config));
	
	    _this[_httpPool] = new _taskPool2.default();
	    _this[_meta] = config.batchMeta;
	    return _this;
	  }
	
	  _createClass(SplunkProvider, [{
	    key: 'onBatch',
	    value: function onBatch(batch) {
	      var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return (0, _http2.default)({
	        url: SPLUNK_ENDPOINT,
	        data: this._createRequest(batch),
	        beacon: meta.manual
	      });
	    }
	  }, {
	    key: '_createRequest',
	    value: function _createRequest(logs) {
	      var request = {
	        logs: logs.map(function (log) {
	          return log.serialize();
	        }),
	        timestamp: new Date()
	      };
	
	      if (this[_meta]) {
	        return _extends({}, request, this[_meta]);
	      }
	
	      return request;
	    }
	  }]);
	
	  return SplunkProvider;
	}(_logProvider2.default);
	
	exports.default = SplunkProvider;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _logProvider = __webpack_require__(13);
	
	var _logProvider2 = _interopRequireDefault(_logProvider);
	
	var _environment = __webpack_require__(1);
	
	var _string = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IS_BROWSER = (0, _environment.isBrowser)();
	
	var GTM_EVENT_NAMES = /pageload/i;
	var GTM_NON_INTERACTION_EVENT_NAMES = /pageload/i;
	
	var _maxTags = (0, _string.uniqueString)('GTMProvider_maxTags');
	var _tags = (0, _string.uniqueString)('GTMProvider_tags');
	
	var parseTag = function parseTag(tag) {
	  return tag.serialize ? tag.serialize() : tag;
	};
	
	var GTMProvider = function (_LogProvider) {
	  _inherits(GTMProvider, _LogProvider);
	
	  _createClass(GTMProvider, null, [{
	    key: 'is',
	    get: function get() {
	      return 'GTMProvider';
	    }
	  }]);
	
	  function GTMProvider(config) {
	    _classCallCheck(this, GTMProvider);
	
	    var _this = _possibleConstructorReturn(this, (GTMProvider.__proto__ || Object.getPrototypeOf(GTMProvider)).call(this, config));
	
	    _this[_tags] = [];
	    _this[_maxTags] = config.maxTags;
	    return _this;
	  }
	
	  _createClass(GTMProvider, [{
	    key: 'log',
	    value: function log() {
	      for (var _len = arguments.length, tags = Array(_len), _key = 0; _key < _len; _key++) {
	        tags[_key] = arguments[_key];
	      }
	
	      if (!IS_BROWSER) return;
	
	      try {
	        tags = tags.filter(GTMProvider.isTag).map(GTMProvider.serialize);
	      } catch (error) {
	        console.error(error);
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var tag = _step.value;
	
	          GTMProvider.dataLayer.push(tag);
	          this[_tags].push(tag);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var diff = this[_tags].length - this[_maxTags];
	
	      if (diff > 0) {
	        this[_tags].splice(0, diff);
	      }
	    }
	  }], [{
	    key: 'isTag',
	    value: function isTag(tag) {
	      var data = parseTag(tag);
	
	      return GTMProvider.isGATag(data) || GTMProvider.isSetiTag(data);
	    }
	  }, {
	    key: 'isGATag',
	    value: function isGATag(tag) {
	      var data = parseTag(tag);
	
	      return !!(data && data.category && data.action);
	    }
	  }, {
	    key: 'isSetiTag',
	    value: function isSetiTag(tag) {
	      var data = parseTag(tag);
	
	      return !!(data && data.event === 'seti' && data.teamName && data.dimension && data.variantName);
	    }
	  }, {
	    key: 'transformEventName',
	    value: function transformEventName() {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      var isEvent = GTM_EVENT_NAMES.test(event);
	      var eventName = isEvent ? event : 'custom';
	
	      return 'gtm-' + eventName + '-event';
	    }
	  }, {
	    key: 'serialize',
	    value: function serialize(tag) {
	      var data = parseTag(tag);
	
	      if (GTMProvider.isGATag(data)) {
	        var eventName = GTMProvider.transformEventName(data.event);
	        var _tag = {
	          'event': eventName,
	          'gtm-event-category': data.category,
	          'gtm-event-action': data.action,
	          'gtm-event-label': data.label
	        };
	
	        if (GTM_NON_INTERACTION_EVENT_NAMES.test(data.event)) {
	          _tag.nonInteraction = 1;
	        }
	
	        return _tag;
	      } else if (GTMProvider.isSetiTag(data)) {
	        var setiTag = {
	          event: 'seti',
	          seti_team_name: data.teamName
	        };
	
	        setiTag['dimension' + data.dimension] = data.variantName;
	
	        return setiTag;
	      }
	    }
	  }, {
	    key: 'dataLayer',
	    get: function get() {
	      var dataLayer = null;
	
	      if (IS_BROWSER) {
	        if (!window.dataLayer) {
	          dataLayer = window.dataLayer = [];
	        } else {
	          dataLayer = window.dataLayer;
	        }
	      }
	
	      return dataLayer;
	    }
	  }]);
	
	  return GTMProvider;
	}(_logProvider2.default);
	
	exports.default = GTMProvider;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _environment = __webpack_require__(1);
	
	var _string = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _handlers = (0, _string.uniqueString)('BrowserErrorHandler_handlers');
	var _onError = (0, _string.uniqueString)('BrowserErrorHandler_onError');
	var _listening = (0, _string.uniqueString)('BrowserErrorHandler_listening');
	
	var BrowserErrorHandler = function () {
	  function BrowserErrorHandler(onError) {
	    _classCallCheck(this, BrowserErrorHandler);
	
	    if (!(0, _environment.isBrowser)() || typeof onError !== 'function') return;
	    if (!BrowserErrorHandler[_handlers]) {
	      BrowserErrorHandler[_handlers] = new Set();
	      BrowserErrorHandler[_listening] = false;
	    }
	
	    this[_onError] = onError;
	
	    this.start();
	  }
	
	  _createClass(BrowserErrorHandler, [{
	    key: 'start',
	    value: function start() {
	      if (BrowserErrorHandler[_handlers].has(this)) return;
	
	      BrowserErrorHandler[_handlers].add(this);
	      BrowserErrorHandler.start();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      BrowserErrorHandler[_handlers].remove(this);
	
	      if (!BrowserErrorHandler[_handlers].size) {
	        BrowserErrorHandler.stop();
	      }
	    }
	  }], [{
	    key: 'start',
	    value: function start() {
	      if (BrowserErrorHandler[_listening]) return;
	
	      var onerror = window.onerror;
	
	      window.onerror = function () {
	        try {
	          if (typeof onerror === "function") onerror.apply(undefined, arguments);
	        } catch (error) {}
	
	        BrowserErrorHandler.handleError.apply(BrowserErrorHandler, arguments);
	      };
	
	      BrowserErrorHandler[_listening] = true;
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!BrowserErrorHandler[_listening]) return;
	
	      window.onerror = null;
	
	      BrowserErrorHandler[_listening] = false;
	    }
	  }, {
	    key: 'handleError',
	    value: function handleError(message, source, lineno, colno, error) {
	      var errorLog = {
	        message: message,
	        source: source,
	        lineno: lineno,
	        colno: colno
	      };
	
	      if (error && error.stack) {
	        errorLog.stack = error.stack;
	      }
	
	      BrowserErrorHandler[_handlers].forEach(function (handler) {
	        try {
	          handler[_onError](errorLog);
	        } catch (error) {}
	      });
	    }
	  }]);
	
	  return BrowserErrorHandler;
	}();
	
	exports.default = BrowserErrorHandler;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _environment = __webpack_require__(1);
	
	var _string = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _handlers = (0, _string.uniqueString)('PageVisibiltyBehavior_handlers');
	var _onChange = (0, _string.uniqueString)('PageVisibiltyBehavior_onChange');
	var _listening = (0, _string.uniqueString)('PageVisibiltyBehavior_listening');
	
	var PageVisibilityBehavior = function () {
	  function PageVisibilityBehavior(onChange) {
	    _classCallCheck(this, PageVisibilityBehavior);
	
	    if (!PageVisibilityBehavior[_handlers]) {
	      PageVisibilityBehavior[_handlers] = new Set();
	      PageVisibilityBehavior[_listening] = false;
	    }
	    if (!(0, _environment.isBrowser)()) return;
	
	    this[_onChange] = onChange || function () {};
	
	    this.start();
	  }
	
	  _createClass(PageVisibilityBehavior, [{
	    key: 'start',
	    value: function start() {
	      if (PageVisibilityBehavior[_handlers].has(this)) return;
	
	      PageVisibilityBehavior[_handlers].add(this);
	      PageVisibilityBehavior.start();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      PageVisibilityBehavior[_handlers].remove(this);
	
	      if (!PageVisibilityBehavior[_handlers].size) {
	        PageVisibilityBehavior.stop();
	      }
	    }
	  }], [{
	    key: 'start',
	    value: function start() {
	      if (PageVisibilityBehavior[_listening]) return;
	
	      var changeBehaviors = PageVisibilityBehavior[_handlers];
	
	      if (!changeBehaviors || !changeBehaviors.size) return;
	
	      document.addEventListener('visibilitychange', PageVisibilityBehavior._onVisiblityChange);
	
	      PageVisibilityBehavior[_listening] = true;
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!PageVisibilityBehavior[_listening]) return;
	
	      document.removeEventListener('visibilitychange', PageVisibilityBehavior._onVisiblityChange);
	
	      PageVisibilityBehavior[_listening] = false;
	    }
	  }, {
	    key: '_onVisiblityChange',
	    value: function _onVisiblityChange() {
	      var hidden = document.visibilityState === 'hidden';
	      PageVisibilityBehavior[_handlers].forEach(function (handler) {
	        try {
	          handler[_onChange](hidden);
	        } catch (error) {}
	      });
	    }
	  }]);
	
	  return PageVisibilityBehavior;
	}();
	
	exports.default = PageVisibilityBehavior;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	  return _extends({}, PCLN_DATA);
	};
	
	exports.updatePCLNData = updatePCLNData;
	
	var _environment = __webpack_require__(1);
	
	var PCLN_DATA = function () {
	  var pclnData = {};
	
	  if ((0, _environment.isBrowser)()) {
	    pclnData = window.PCLN_BOOTSTRAP_DATA || window.requestHandlerData || {};
	  } else {
	    pclnData = {
	      appName: "",
	      appVersion: "-.-.-",
	      node: true
	    };
	  }
	
	  return pclnData;
	}();
	
	function updatePCLNData(data) {
	  if ((typeof data === "undefined" ? "undefined" : _typeof(data)) !== 'object') return;
	
	  return _extends({}, PCLN_DATA, data);
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pclnData = __webpack_require__(18);
	
	var _pclnData2 = _interopRequireDefault(_pclnData);
	
	var _object = __webpack_require__(20);
	
	var _string = __webpack_require__(8);
	
	var _environment = __webpack_require__(1);
	
	var _localStorageCheck = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _state = (0, _string.uniqueString)('Storage_state');
	
	var STORAGE_KEY = '[STATE] > ' + (0, _pclnData2.default)().appName;
	
	var Storage = function () {
	  function Storage() {
	    _classCallCheck(this, Storage);
	
	    this[_state] = null;
	  }
	
	  _createClass(Storage, [{
	    key: 'get',
	    value: function get(key) {
	      return (0, _object.copy)((0, _object.traverse)(this[_state], key));
	    }
	  }, {
	    key: 'save',
	    value: function save(key, value) {
	      if (!key) return;
	
	      var state = this.state;
	      var parts = key.split(/\./);
	
	      if (parts.length > 1) {
	        var parentParts = parts.slice(0, parts.length - 1);
	        var parentPath = _string.dotpath.apply(undefined, _toConsumableArray(parentParts));
	        var finalKey = parts[parts.length - 1];
	        var parent = (0, _object.traverse)(state, parentPath);
	
	        if (!(0, _object.determine)(parent).object) {
	          var current = state;
	
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = parentParts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var part = _step.value;
	
	              if (!(0, _object.determine)(current[part]).object) {
	                current = current[part] = {};
	              } else {
	                current = current[part];
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          parent = current;
	        }
	
	        parent[finalKey] = value;
	      } else {
	        state[key] = value;
	      }
	
	      this[_state] = state;
	
	      if ((0, _environment.isBrowser)() && (0, _localStorageCheck.isLocalStorageAvailable)()) {
	        localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
	      }
	    }
	  }, {
	    key: 'state',
	    get: function get() {
	      if (!(0, _environment.isBrowser)()) return {};
	      if (!this[_state]) {
	        var stored = (0, _localStorageCheck.isLocalStorageAvailable)() ? localStorage.getItem(STORAGE_KEY) : null;
	        var is = (0, _object.determine)(stored);
	
	        if (!is.object) {
	          this[_state] = {};
	        } else {
	          this[_state] = JSON.parse(stored) || {};
	        }
	      }
	
	      return (0, _object.copy)(this[_state]);
	    }
	  }]);
	
	  return Storage;
	}();
	
	var INSTANCE = new Storage();
	exports.default = INSTANCE;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.copy = copy;
	exports.traverse = traverse;
	exports.determine = determine;
	exports.isObject = isObject;
	function copy(obj) {
	  var is = determine(obj);
	  var newObj = null;
	
	  if (is.object && !is.array) {
	    newObj = {};
	
	    for (var prop in obj) {
	      var value = obj[prop];
	
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value instanceof Date === false) {
	        newObj[prop] = copy(value);
	      } else {
	        newObj[prop] = value;
	      }
	    }
	  } else if (is.array) {
	    newObj = [];
	
	    for (var i = 0; i < obj.length; ++i) {
	      newObj[i] = copy(obj[i]);
	    }
	  } else {
	    return obj;
	  }
	
	  return newObj;
	}
	
	function traverse(obj, path) {
	  var parts = path.split('.');
	  var is = determine(obj);
	
	  var current = obj;
	
	  if (is.object && !is.array) {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var part = _step.value;
	
	        current = current[part];
	
	        if (!current) return undefined;
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	
	  return current;
	}
	
	function determine(obj) {
	  var object = isObject(obj);
	  var array = Array.isArray(obj);
	
	  return { object: object, array: array };
	}
	
	function isObject(obj) {
	  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj instanceof Date === false;
	}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isLocalStorageAvailable = exports.isLocalStorageAvailable = function isLocalStorageAvailable() {
	  if (!window.localStorage) {
	    return false;
	  }
	  try {
	    window.localStorage.setItem('isLocalStorageAvailable', true);
	    window.localStorage.removeItem('isLocalStorageAvailable');
	    return true;
	  } catch (e) {
	    return false;
	  }
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.APP_LOCALE = exports.APP_VERSION = exports.APP_NAME = exports.VERSION = exports.NAME = undefined;
	
	var _pclnData = __webpack_require__(18);
	
	var _pclnData2 = _interopRequireDefault(_pclnData);
	
	var _string = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = function data() {
	  var PCLN_DATA = (0, _pclnData2.default)();
	
	  return {
	    NAME: 'PCLNAnalytics',
	    VERSION: (0, _string.version)('1.0.0'),
	    APP_NAME: PCLN_DATA.appName || '',
	    APP_VERSION: PCLN_DATA.appVersion || '',
	    APP_LOCALE: PCLN_DATA.locale || ''
	  };
	};
	
	var _data = data(),
	    NAME = _data.NAME,
	    VERSION = _data.VERSION,
	    APP_NAME = _data.APP_NAME,
	    APP_VERSION = _data.APP_VERSION,
	    APP_LOCALE = _data.APP_LOCALE;
	
	exports.NAME = NAME;
	exports.VERSION = VERSION;
	exports.APP_NAME = APP_NAME;
	exports.APP_VERSION = APP_VERSION;
	exports.APP_LOCALE = APP_LOCALE;
	exports.default = data;

/***/ })
/******/ ])
});
;
//# sourceMappingURL=pcln-analytics.js.map